module.exports = __webpack_public_path__ + "15088bc5db8fadfb9d92a64c7e3ebef1.png";